import { EPagesMobileTabs } from '@/enums/EPagesMobileTabs';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import i18n_page_settings_user from '@/locales/keys/i18n_page_settings_user.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { SVGComponent } from '@/types/types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ENUM__settings_user_tab } from './_base/ENUM__settings_user_tab';

export interface Props {
  type: string;
  Icon?: SVGComponent;
  setActiveTab?: React.Dispatch<React.SetStateAction<string>>;
}

export function S_BUTTON__settings_user_tab({ type, Icon, setActiveTab }: Props) {
  //FIELDS
  const dispatch = use_dispatch();

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);

  const { page_settings_user_current_tab } = use_slice_ui(['page_settings_user_current_tab']);

  const [isMouseOver, setIsMouseOver] = useState(false);

  /*
   * EVENTS
   */

  function onClick() {
    dispatch(
      LOCAL__ui_set_string({
        key: 'page_settings_user_current_tab',
        value: type,
        valid_values: Object.values(ENUM__settings_user_tab),
      }),
    );

    setActiveTab?.(EPagesMobileTabs.SETTINGS_PARAMS);
  }

  /*
   * RENDERS
   */

  function render_icon() {
    if (!Icon) return <></>;

    let out = <></>;

    return (
      <Icon className={`!size-5 hover-animation ${isMouseOver || page_settings_user_current_tab == type ? '!text-bar' : '!text-component-item-foreground'}`} />
    );
  }

  /*
   * HTML
   */
  return (
    <>
      <div
        className={`list-item-wrapper hover-animation gap-5
          px-1
        ${page_settings_user_current_tab == type || isMouseOver ? 'list-item-selected ' : ''}`}
        onClick={onClick}
        onMouseEnter={() => setIsMouseOver(true)}
        onMouseLeave={() => setIsMouseOver(false)}
      >
        {render_icon()}
        <div className="list-item-inner">
          <p className={`text-left m-0`}>{t(i18n_page_settings_user.tabs[type].title)}</p>
        </div>
      </div>
    </>
  );
}
